import { useMemo } from 'react'
import { useTable, ColumnInstance, Row } from 'react-table'
import { CustomHeaderColumn } from './columns/CustomHeaderColumn'
import { CustomRow } from './columns/CustomRow'
import { useQueryResponseData, useQueryResponseLoading } from '../core/QueryResponseProvider'
import { logsColumns } from './columns/_columns'
import { Log } from '../core/_models'
import { LogsListLoading } from '../components/loading/LogsListLoading'
import { LogsListPagination } from '../components/pagination/LogsListPagination'
import { KTCardBody } from '../../../../../../_metronic/helpers'

const LogsTable = () => {

  const logs = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => logs, [logs])
  const columns = useMemo(() => logsColumns, [])
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } = useTable({
    columns,
    data,
  })
  return (
    <KTCardBody className='py-4'>
      <div className="table-responsive">

        <table id='kt_table_users' className='table align-middle table-row-dashed gy-1 dataTable no-footer' {...getTableProps()}>

          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Log>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Log>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    Logs sin registrar
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <LogsListPagination />
      {isLoading && <LogsListLoading />}
    </KTCardBody>
  )
}

export { LogsTable }
